import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetOrderList } from '@/api/DeliveryCode';
import util from '@/libs/util';
import store from '@/store/index';
export default {
  props: {
    isShowChangeOrderDialog: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      keyName: 'BILL_NO',
      keyList: [{
        value: 'ALL',
        label: '全部'
      }, {
        value: 'BILL_NO',
        label: '采购订单号'
      }, {
        value: 'PART_NO',
        label: '物料编码'
      }, {
        value: 'PART_NAME',
        label: '物料名称'
      }, {
        value: 'PART_DESCR',
        label: '规格描述'
      }, {
        value: 'PO_UNIT',
        label: '采购单位'
      }],
      keyCode: null,
      DELIVERY_NO: null
    };
  },
  methods: {
    // 单据类型搜索选择
    handelChangeKeyType: function handelChangeKeyType() {
      this.keyCode = null;

      if (this.keyName === 'ALL') {
        this._getErpPOlist();
      }
    },
    currentChange: function currentChange(_ref) {
      var newValue = _ref.newValue,
          oldValue = _ref.oldValue,
          row = _ref.row,
          rowIndex = _ref.rowIndex,
          $rowIndex = _ref.$rowIndex,
          column = _ref.column,
          columnIndex = _ref.columnIndex,
          $columnIndex = _ref.$columnIndex,
          $event = _ref.$event;
      // console.log(row);
      // console.log(rowIndex);
      // console.log($rowIndex);
      this.$refs.xTable.setRadioRow(this.tabelData[rowIndex]);
    },
    // 行样式
    rowClassName: function rowClassName() {
      return 'rowClass';
    },
    _getOrderlist: function _getOrderlist() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('currentRow',currentRow);
                _this.tabelData = [];
                params = {
                  Page: 1,
                  Limit: 10,
                  ORGANIZE_ID: util.cookies.get('ORG_ID') // LIST_ROUTE:store.getters.routerPath,

                };
                _this.loading = true;
                _context.next = 5;
                return GetOrderList(params);

              case 5:
                res = _context.sent;
                _this.loading = false;
                console.log('送货单列表', res);

                if (res.code === 0) {
                  _this.tabelData = res.data.Items;
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 去重
    deWeight: function deWeight(asyncRow, currentRow) {
      // let currentRow = this.$refs.xTable.getTableData().visibleData
      // return asyncRow.filter((v) => currentRow.every((val) => val.PO_NO != v.BILL_NO && val.BILL_ITEM != v.PO_ITEM && val.BILL_ITEM != v.PO_ITEM));
      return asyncRow.filter(function (v) {
        return currentRow.every(function (val) {
          return val.PO_NO != v.PO_NO && val.BILL_ITEM != v.BILL_ITEM && val.BILL_ITEM != v.BILL_ITEM;
        });
      });
    },
    getOrderlist: function getOrderlist() {
      this._getOrderlist();
    },
    handleCancel: function handleCancel() {
      this.$emit('closeChangeOrderDialog');
    },
    // 获取当前时间
    getNowDate2: function getNowDate2(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    // 获取当前时间
    getNowDate: function getNowDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y.toString() + m.toString() + d.toString();
    },
    handleDelSubmit: function handleDelSubmit() {
      var selectRecords = this.$refs.xTable.getRadioRecord(); // console.log('selectRecords',selectRecords);

      this.$emit('cbDialogSubmit', selectRecords);
      this.$emit('closeChangeOrderDialog');
    }
  }
};